import { Theme } from "@120wateraudit/waterworks";
import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import styled from "styled-components";

interface Props {
  onClose: () => void;
  onConfirm: () => Promise<unknown>;
}

const RemoveOverdueModal = ({ onClose, onConfirm }: Props): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const confirm: () => Promise<void> = async () => {
    setLoading(true);
    if (await onConfirm()) {
      onClose();
    }
    setLoading(false);
  };

  return (
    <>
      <ModalContentContainer>
        <ModalHeader>
          Are you sure you want to manually remove the Overdue status on this
          submission?
        </ModalHeader>
        <ContentHeader>
          Once the Overdue status is removed on this submission, it{" "}
          <b>cannot</b> be marked Overdue again.
        </ContentHeader>
        <RemoveOverdueButtonWrapper>
          <RemoveOverdueButton disabled={loading} onClick={confirm}>
            Remove Overdue Status
          </RemoveOverdueButton>
        </RemoveOverdueButtonWrapper>
        <Button disabled={loading} onClick={onClose}>
          Cancel
        </Button>
      </ModalContentContainer>
    </>
  );
};

const ModalContentContainer = styled.div`
  display: flex;
  margin: 0;
  justify-content: center;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding-bottom: 24px;
`;

const ModalHeader = styled.h3`
  display: flex;
  padding: 16px;
  font-weight: 600;
  padding-bottom: 0;
  margin-bottom: 0px;
  text-align: center;
`;

const ContentHeader = styled.h4`
display: flex
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  width: 100%;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 0;
`;

const RemoveOverdueButtonWrapper = styled.div`
  margin-bottom: 1rem;
  margin-top: 2rem;
`;

const RemoveOverdueButton = styled(Button)`
  &&& {
    background-color: ${Theme.palette.primary};
    color: ${Theme.palette.neutral900};
  }
`;

export default RemoveOverdueModal;
